module.exports = __webpack_public_path__ + "static/media/tick.05f549db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/tick.svg
// module id = 4063
// module chunks = 0